<template>
  <v-container>
    <v-layout row>
      <v-data-table
        :headers="headers"
        :items="items1"
        class="elevation-1"
        rows-per-page-text="จำนวนข้อมูลที่แสดง"
      >
        <template v-slot:items="props">
          <td>{{ props.item.work }}</td>
          <td>{{ props.item.docPlace }}</td>
          <td>{{ props.item.docId }}</td>
          <td>{{ props.item.docDetail }}</td>
          <td>{{ props.item.income }}</td>
        </template>
        <template v-slot:pageText="props">
          ข้อมูลชุดที่ {{ props.pageStart }} - {{ props.pageStop }} จาก
          {{ props.itemsLength }}
        </template>
      </v-data-table>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        { text: "ระบบงาน", value: "work", sortable: false },
        { text: "ทะเบียน", value: "docPlace", sortable: false },
        { text: "เลขที่ใบเสร็จ", value: "docId", sortable: false },
        { text: "รายละเอียดค่าธรรมเนียม", value: "docDetail", sortable: false },
        { text: "จำนวนเงิน (บาท)", value: "income", sortable: false }
      ],
      items1: [
        {
          work: "งานทะเบียนครอบครัว",
          docPlace: "ทะเบียนสมรส",
          docId: "1/2562",
          docDetail: "คัดสำเนาทะเบียน",
          income: 10
        },
        {
          work: "งานทะเบียนครอบครัว",
          docPlace: "ทะเบียนการหย่า",
          docId: "2/2562",
          docDetail: "คัดสำเนาทะเบียน",
          income: 10
        },
        {
          work: "งานทะเบียนครอบครัว",
          docPlace: "ทะเบียนรับรองบุตร",
          docId: "3/2562",
          docDetail: "คัดสำเนาทะเบียน",
          income: 10
        },
        {
          work: "งานทะเบียนชื่อสกุล",
          docPlace: "ช.3",
          docId: "1/2562",
          docDetail: "ออกหนังสือสำคัญการเปลี่ยนชื่อตัว",
          income: 50
        },
        {
          work: "งานทะเบียนชื่อสกุล",
          docPlace: "ช.2",
          docId: "2/2562",
          docDetail: "ออกหนังสือสำคัญการตั้งชื่อสกุล",
          income: 100
        },
        {
          work: "งานทะเบียนชื่อสกุล",
          docPlace: "ทะเบียนสมรส",
          docId: "3/2562",
          docDetail: "คัดสำเนาทะเบียน",
          income: 10
        },
        {
          work: "งานทะเบียนพินัยกรรม",
          docPlace: "พ.ก.2",
          docId: "1/2562",
          docDetail: "ออกหนังสือสำคัญการเปลี่ยนชื่อตัว",
          income: 50
        }
      ]
    };
  }
};
</script>

<style></style>
